import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';

export interface LocationItem {
  id: string;
  locationName: string;
  addressLine: string;
}

export interface LocationListResponse {
  statusCode: number;
  message: string;
  total: number;
  locations: LocationItem[];
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private readonly apiService = inject(ApiService);

  getActiveLocations(): Observable<LocationListResponse> {
    return this.apiService.get<LocationListResponse>(API_ENDPOINTS.LOCATIONS.LIST).pipe(
      map((response) => this.normalizeLocationListResponse(response))
    );
  }

  /** Locations assigned to the signed-in staff (fresh from API for mid-session switch). */
  getMyAssignedLocations(): Observable<LocationListResponse> {
    return this.apiService.get<LocationListResponse>(API_ENDPOINTS.LOCATIONS.MINE).pipe(
      map((response) => this.normalizeLocationListResponse(response))
    );
  }

  private normalizeLocationListResponse(response: LocationListResponse): LocationListResponse {
    return {
      statusCode: response.statusCode ?? 200,
      message: response.message ?? '',
      total: response.total ?? response.locations?.length ?? 0,
      locations: (response.locations ?? []).map((location) => ({
        id: String(location.id ?? ''),
        locationName: String(location.locationName ?? ''),
        addressLine: String(location.addressLine ?? ''),
      })),
    };
  }
}
